import { render, staticRenderFns } from "./alertSuspended.vue?vue&type=template&id=6f2960ec&scoped=true"
import script from "./alertSuspended.vue?vue&type=script&lang=js"
export * from "./alertSuspended.vue?vue&type=script&lang=js"
import style0 from "./alertSuspended.vue?vue&type=style&index=0&id=6f2960ec&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2960ec",
  null
  
)

export default component.exports